import React from "react";
import { toLocalDateString } from "@hex-insights/core";
import {
	Student,
	StudentAttendanceNotesListQuery,
	StudentFilterInput,
	StudentNoteNoteType,
	useStudentAttendanceNotesListQuery,
} from "../../../Utilities";

export function useStudentAttendanceNotesOnDate(
	studentFilters: StudentFilterInput,
	date = toLocalDateString(new Date()),
	skip = false,
) {
	const {
		loading,
		data: attendanceNoteData,
		error,
	} = useStudentAttendanceNotesListQuery({
		variables: {
			filters: {
				noteTypeEQ: StudentNoteNoteType.Attendance,
				studentAttendanceNote: [{ startDateLTE: date, endDateGTE: date }],
				primaryStudents: [studentFilters],
			},
			studentFilters: studentFilters,
		},
		fetchPolicy: "network-only",
		skip,
	});
	const { studentAttendanceNotesMap, attendanceNotes } = React.useMemo(() => {
		const map: Record<Student["id"], StudentAttendanceNotesListQuery["studentNoteConnection"]["edges"][0]["node"][]> =
			{};
		const list: StudentAttendanceNotesListQuery["studentNoteConnection"]["edges"][0]["node"][] = [];

		if (!attendanceNoteData) {
			return { studentAttendanceNotesMap: map, attendanceNotes: list };
		}

		for (let i = 0; i < attendanceNoteData.studentNoteConnection.edges.length; i++) {
			const note = attendanceNoteData.studentNoteConnection.edges[i].node;
			list.push(note);
			for (let j = 0; j < note.primaryStudents.length; j++) {
				const student = note.primaryStudents[j];
				if (!map[student.id]) {
					map[student.id] = [];
				}
				map[student.id].push(note);
			}
		}

		return { studentAttendanceNotesMap: map, attendanceNotes: list };
	}, [attendanceNoteData]);

	return { loading, error, attendanceNoteData, studentAttendanceNotesMap, attendanceNotes };
}
